export default __webpack_public_path__ + "static/media/defaultBanner.37090d3f.svg";